// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"Delete_ModalContainer__3Be3U","ModalContent":"Delete_ModalContent__3tj9n","ModalActions":"Delete_ModalActions__1fBca","ModalButton":"Delete_ModalButton__uJGl1"};